import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import styles from './Header.module.css';

const Header = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();
  const { cartCount, fetchCartItems } = useCart();
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const guestEmail = localStorage.getItem('guest_email');

  const getUserLabel = () => {
    if (user.role === 'admin') return `Admin: ${user.email}`;
    if (guestEmail) return `Invitado: ${guestEmail}`;
    return 'Mi Cuenta';
  };

  const handleLogout = () => {
    if (user.role === 'admin') {
      localStorage.removeItem('user');
      alert('Sesión admin cerrada');
    } else {
      localStorage.removeItem('guest_email');
      alert('Email de invitado removido');
    }
    window.location.reload();
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchTerm.trim())}`);
      setSearchTerm('');
    }
  };

  return (
    <header className={styles.header}>
      <div className={styles.topBar}>
        <div className={styles.container}>
          <span></span>
          {(user.role === 'admin' || guestEmail) && (
            <span className={styles.userInfo}>
              {getUserLabel()}
              <button onClick={handleLogout} className={styles.logoutBtn}>
                Cerrar
              </button>
            </span>
          )}
        </div>
      </div>

      <div className={styles.mainHeader}>
        <div className={styles.container}>
          <div className={styles.logoSection}>
            <Link to="/" className={styles.logo}>
              <img src="/Nexa-Globals-Hlogo-removebg-preview.png" alt="Nexa Global Logo" />
            </Link>
          </div>

          <div className={styles.searchSection}>
            <form onSubmit={handleSearch} className={styles.searchBar}>
              <input
                type="text"
                placeholder="Buscar productos..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className={styles.searchInput}
              />
              <button type="submit" className={styles.searchButton}>🔍</button>
            </form>
          </div>

          <div className={styles.userSection}>
            <Link to="/Login" className={styles.headerLink}>
              <span className={styles.icon}>👤</span>
              <span>Mi Cuenta</span>
            </Link>
            <Link 
              to="/cart" 
              className={styles.headerLink}
              onClick={fetchCartItems} // Actualiza el carrito al hacer clic
            >
              <span className={styles.icon}>🛒</span>
              <span>Carrito({cartCount})</span>
            </Link>
          </div>
        </div>
      </div>

      <nav className={styles.navigation}>
        <div className={styles.container}>
          <Link to={`/search?category_slug=electronicos`}>Electrónicos</Link>
          <Link to={`/search?category_slug=hogar`}>Hogar</Link>
          <Link to={`/search?category_slug=deportes`}>Deportes</Link>
          {user.role === 'admin' && (
            <Link to="/admin/dashboard" className={styles.adminLink}>
              🛠️ Panel Admin
            </Link>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Header;